export default __webpack_public_path__ + "static/media/temp.4f086630.svg";